<template>
  <div>
    <Tabs type="card">
      <TabPane label="质疑登记">
        <questionRegister></questionRegister>
      </TabPane>
      <TabPane label="投诉登记">
        <complaintRegister></complaintRegister>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import QuestionRegister from './questionRegister'
import ComplaintRegister from './complaintRegister'

export default {
  name: 'complaintsRegistration',
  components: {
    QuestionRegister,
    ComplaintRegister
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>

</style>
